import styled from 'particles/themes/styled'

export const SubmissionFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[300]};

    .btn-group {
        display: flex;
        justify-content: space-between;
    }
`
